export enum TimeframeEnum {
  Today = 0,
  Last30days = 1,
  CurrentWeek = 2,
  PreviousWeek = 3,
  CurrentMonth = 4,
  PreviousMonth = 5,
  Custom = 6
}